import { useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { organizationActions } from "../../../../Services/Redux/actionCreators";
import { assetTypes } from "../../../../Utils/FileUpload";
import { checkIfKnownError } from "shared/dist/utils/error";
import { SNETImageUpload, AlertBox, alertTypes } from "shared/dist/components";
import classes from "./OrgImg.module.css";

const OrgImg = () => {
    const [imgUploadAlert, setImgUploadAlert] = useState({});
    const [attachments, setAttachments] = useState([]);

    const url = useSelector((state) => state.organization.assets.heroImage.url);
    const imageRef = useRef(null);
    const { orgUuid } = useParams();

    const dispatch = useDispatch();

    const handleImageChange = async (data) => {
        try {
            setImgUploadAlert({});
            const { url } = await dispatch(
                organizationActions.uploadFile(assetTypes.ORG_ASSETS, data, orgUuid)
            );
            setAttachments([
                {
                    file: data,
                    url,
                },
            ]);
            dispatch(organizationActions.setOrgHeroImageUrl(url));
            return url;
        } catch (e) {
            imageRef.current.uploadedStateImg.current.src = "";
            if (checkIfKnownError(e)) {
                return setImgUploadAlert({ type: alertTypes.ERROR, message: e.message });
            }
            return setImgUploadAlert({
                type: alertTypes.ERROR,
                message: "Unable to upload image. Please try later",
            });
        }
    };

    return (
        <div className={classes.orgImgContainer}>
            <Typography variant="h6" className={classes.title}>
                Organisation Profile Image
            </Typography>
            <Grid container spacing={2} className={classes.profileImgContainer}>
                <Grid size={{ xs: 12, sm: 6 }} className={classes.orgProfileImg}>
                    <SNETImageUpload
                        attachments={attachments}
                        setAttachments={setAttachments}
                        maxImageSizeMB={1}
                        handleImageChange={handleImageChange}
                    />
                    <AlertBox type={imgUploadAlert.type} message={imgUploadAlert.message} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }} className={classes.previewContainer}>
                    <Typography className={classes.previewText}>
                        Every organization will have a profile image. We recommend an image that is
                        906 x 504 in size. You can preview how it will look on the AI Marketplace.
                    </Typography>
                    <div className={classes.previewImg}>
                        <div className={classes.previewLargeImg}>
                            <Typography>Preview</Typography>
                            <Avatar
                                alt="Singularity"
                                src={url}
                                className={classes.largePreviewImg}
                            />
                        </div>
                        <div className={classes.previewSmallImg}>
                            <Avatar
                                alt="Singularity"
                                src={url}
                                className={classes.smallPreviewImg}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default OrgImg;
